
import * as type from '../../types/user'

const reducer = (state = {}, action) => {
    switch (action.type) {
        case type.FETCH_LOGGEDIN_USER:
            return action.payload
        default:
            return state
    }
}

export default reducer